import { AiExampleCategory, IAiExampleQuestion } from "../models/aiExampleQuestions";

export const AI_EXAMPLE_CHIPS = 4;

/**
 * Picks `count` example questions at random, each from a different category while categories last, so the
 * chips show a mix (a client, the schedule, a number, a trend, an idea…) and change every time.
 * Owner-or-manager questions are left out for the other staff, whose tools can't answer them.
 */
export const pickExampleQuestions = (
  pool: IAiExampleQuestion[],
  canSeeAnalytics: boolean,
  count: number = AI_EXAMPLE_CHIPS,
  random: () => number = Math.random,
): string[] => {
  const allowed = pool.filter((question) => canSeeAnalytics || !question.managersOnly);

  // Fisher–Yates on a copy.
  const shuffled = [...allowed];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  const picked: IAiExampleQuestion[] = [];
  const usedCategories = new Set<AiExampleCategory>();
  for (const question of shuffled) {
    if (picked.length === count) break;
    if (!usedCategories.has(question.category)) {
      picked.push(question);
      usedCategories.add(question.category);
    }
  }
  // Fewer categories than chips: fill up with the rest.
  for (const question of shuffled) {
    if (picked.length === count) break;
    if (!picked.includes(question)) picked.push(question);
  }

  return picked.map((question) => question.text);
};
